module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/background.1be71328.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/background.png
// module id = 2745
// module chunks = 11